import { useLanguage } from 'providers';
import { useRouter } from 'common/hooks/useRouter';
import { ResourceType } from 'types';
import { MachineHealthSubTabs } from 'types/protein';
import { fleetPageRoute } from 'common/pages/fleetV2/settings/fleetPageRoutes';
import {
  useGetMachineAssetsQuery,
  useGetMachineConfiguratorDataQuery
} from 'api';

export const useMachineOverviewWidgetConfiguratorData = () => {
  const { id } = useRouter(fleetPageRoute) as { id: string };
  const { languageId } = useLanguage();

  const { data: configuratorData } = useGetMachineConfiguratorDataQuery({
    machineId: id,
    labels: [MachineHealthSubTabs.OverviewMain],
    languageId
  });

  return { configuratorData };
};

type UseMachineOverviewWidgetAssetsProps = {
  machineId?: string;
  pollingInterval?: number;
};

export const useMachineOverviewWidgetAssets = ({
  machineId,
  pollingInterval
}: UseMachineOverviewWidgetAssetsProps = {}) => {
  const { id } = useRouter(fleetPageRoute) as { id: string };

  const { data: machineAssets, isLoading: machineAssetsIsLoading } = useGetMachineAssetsQuery(
    {
      machineId: machineId ?? id,
      assetType: ResourceType.MachineImage
    },
    { pollingInterval }
  );

  return { machineAssets, machineAssetsIsLoading };
};
